// Import model
import { PhoneField } from '../models/PhoneField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PhoneField - handles JSON serialization and deserialization with type validation
 */
export class PhoneFieldSerializer {
  /**
   * Deserializes a JSON string into a PhoneField instance
   */
  static deserialize(json: string): PhoneField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PhoneField instance
   */
  static fromObject(obj: any): PhoneField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PhoneField');
    }


    const instance: PhoneField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      _87B739Dd: obj['_87b739dd'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PhoneField instances
   */
  static deserializeArray(json: string): PhoneField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PhoneField instance to a JSON string
   */
  static serialize(instance: PhoneField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PhoneField instance to a plain object
   */
  static toObject(instance: PhoneField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_87b739dd': instance._87B739Dd,
    };
  }

  /**
   * Serializes an array of PhoneField instances to a JSON string
   */
  static serializeArray(instances: PhoneField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
